interface Props {
    name: string;
    type: string;
    placeholder?: string;
    [x: string]: any
}

export const CustomLabel = (props: Props) => {

    return (
        <>
            <label htmlFor={props.name || props.id}> {props.placeholder} </label>
        </>
    )
}